import RtMeasurementsTab from "@/themes/Pompei/Components/RtMeasurements/RtMeasurementsTab.vue";
import PompeiUnitaCatastaleMonitoringTab from "@/themes/Pompei/Components/Monitoring/PompeiUnitaCatastaleMonitoringTab.vue";
import {
  POMPEI_SHEET_TAB_NAMES,
  POMPEI_TOPOGRAPHIC_SHEET_NAMES,
} from "@/utils/sheetTabPresentation";

// Expose the rectified-image measurements viewer on every Pompei topographic
// sheet that can show the `pompei_rt_misure` tab. Built from the same list that
// gates the tab in useSheetContentPresentation so registration and visibility
// stay in sync.
const pompeiRtMeasurementsTabs = Object.fromEntries(
  POMPEI_TOPOGRAPHIC_SHEET_NAMES.map((sheetName) => [
    sheetName,
    { [POMPEI_SHEET_TAB_NAMES.rtMisure]: RtMeasurementsTab },
  ]),
);

const domainSpecificTabs = {
  Pompei: {
    ...pompeiRtMeasurementsTabs,
    unita_catastale: {
      [POMPEI_SHEET_TAB_NAMES.ucMonitoraggio]: PompeiUnitaCatastaleMonitoringTab,
    },
  },
};

export const resolveDomainSpecificTabComponent = ({ theme, sheetName, tabName }) => {
  return domainSpecificTabs?.[theme]?.[sheetName]?.[tabName] ?? null;
};